import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Typography } from '@mui/material';
import React from 'react';

const PrototypeDisclaimer: React.FC = () => {
  return (
    <Box
      sx={{
        bgcolor: '#FEF3C7',
        borderBottom: '1px solid #F59E0B',
        px: 3,
        py: 1.5,
        display: 'flex',
        alignItems: 'flex-start',
        gap: 1.5,
        fontFamily: 'Manrope, sans-serif',
      }}
    >
      <InfoOutlinedIcon sx={{ color: '#D97706', fontSize: 20, mt: 0.25 }} />
      <Box>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 600,
            color: '#92400E',
            fontSize: 13,
            lineHeight: 1.4,
            fontFamily: 'Manrope, sans-serif',
          }}
        >
          Prototype Preview - For Demonstration Purposes Only
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: '#A16207',
            fontSize: 12,
            lineHeight: 1.5,
            display: 'block',
            mt: 0.25,
            fontFamily: 'Manrope, sans-serif',
          }}
        >
          This is an interactive prototype intended to demonstrate application flow and user
          experience concepts. Visual styling, colors, spacing, and UI elements may differ from the
          final Figma designs. This prototype does not represent the final product and is subject to
          change based on design reviews and stakeholder feedback. Please do not use this as a
          reference for pixel-perfect implementation.
        </Typography>
      </Box>
    </Box>
  );
};

export default PrototypeDisclaimer;
